import { useQuery } from "@tanstack/react-query";
import { getJson } from "../client";

const queryKey = ["places"];

export function usePlaces(options = {}) {
  return useQuery({
    queryKey,
    queryFn: async () => {
      const fields = [
        "id",
        "place",
        "articles.Articles_id.id",
        "articles.Articles_id.translations.title",
        "articles.Articles_id.translations.languages_code",
        "articles.Articles_id.published_at",
      ].join(",");

      const { data } = await getJson("/items/Places", {
        fields,
        sort: "id",
      });
      // Ensure place is parsed JSON object if server returns string
      return (data || []).map((row) => ({
        id: row.id,
        place: typeof row.place === "string" ? safeParse(row.place) : row.place,
        articles: row.articles,
      }));
    },
    staleTime: 60_000,
    refetchOnWindowFocus: false,
    ...options,
  });
}

function safeParse(value) {
  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
}
